import React, { Dispatch, SetStateAction } from 'react'
import { mdiDeleteOutline } from '@mdi/js'

import { makePublicUrl } from 'app/utils/publicUrl'
import {
  ClaimDeviceAppNameLabel,
  ClaimDeviceBlock,
  ClaimDeviceBlocksContainer,
  ClaimDeviceDeleteButton,
  ClaimDeviceIcon,
  ClaimDeviceIconDelete,
  ClaimDeviceInputControl,
  ClaimDeviceLabel,
} from './styles'
import {
  ClaimDeviceWhiteBlock,
  ClaimDeviceInputControlContainer,
} from '../styles'

interface ClaimDeviceNameFormProps {
  onEraseDataClick: () => void
  deviceDataMac: string
  deviceDataCode: string
  deviceAppName: string
  setDeviceAppName: Dispatch<SetStateAction<string>>
}

function ClaimDeviceNameForm({
  onEraseDataClick,
  deviceDataMac,
  deviceDataCode,
  deviceAppName,
  setDeviceAppName,
}: ClaimDeviceNameFormProps) {
  return (
    <ClaimDeviceWhiteBlock>
      <ClaimDeviceBlocksContainer>
        <ClaimDeviceDeleteButton type="button" onClick={onEraseDataClick}>
          <ClaimDeviceIconDelete path={mdiDeleteOutline} size={1} />
        </ClaimDeviceDeleteButton>

        <ClaimDeviceBlock>
          <ClaimDeviceIcon
            src={makePublicUrl(
              `images/networkIcons/access-points-pelicanGrey.svg`
            )}
          />
          <ClaimDeviceLabel></ClaimDeviceLabel>
          <ClaimDeviceInputControlContainer>
            <ClaimDeviceInputControl
              placeholder={'MAC'}
              defaultValue={deviceDataMac}
              disabled
              showLabel
            />
            <ClaimDeviceInputControl
              placeholder={'Code'}
              defaultValue={deviceDataCode}
              disabled
              showLabel
            />
          </ClaimDeviceInputControlContainer>
        </ClaimDeviceBlock>

        <ClaimDeviceBlock>
          <ClaimDeviceAppNameLabel>Add AP Name</ClaimDeviceAppNameLabel>
          <ClaimDeviceInputControlContainer>
            <ClaimDeviceInputControl
              placeholder={'AP Name'}
              defaultValue={deviceAppName}
              onChange={(event) => setDeviceAppName(event.target.value)}
              showLabel={!!deviceAppName}
            />
          </ClaimDeviceInputControlContainer>
        </ClaimDeviceBlock>
      </ClaimDeviceBlocksContainer>
    </ClaimDeviceWhiteBlock>
  )
}

export default ClaimDeviceNameForm
